import date from './date'
export default function filterRequestResult(data) {
  data = data.map(function(item) {
    if(item.CreateTime) {
      item.CreateTime = date('Y-m-d H:i',new Date(item.CreateTime).getTime()/1000)
    }

    if(item.CurrentTime) {
      item.CurrentTime = date('Y-m-d H:i',new Date(item.CurrentTime).getTime()/1000)
    }

    return item
  })

  return data
}



// WEBPACK FOOTER //
// ./src/assets/js/lib/filterRequestResult.js